import { TextSizePerformBegin } from './performSteps/TextSizePerformBegin';
import { TextSizeGroupItems } from './TextSizePerformChilds';
// import { TextSizePerformEnd } from './performSteps/TextSizePerformEnd';
import { TextSizePerformGrow } from './performSteps/TextSizePerformGrow';
import { TextSizeBorders } from './borders/TextSizeAllBorders';
import { TextSizePerformShrink } from './performSteps/TextSizePerformShrink';
export class GroupSizePerformer {
    MAX_LOOPS = 100;
    parent;
    beginPerformer = new TextSizePerformBegin(this);
    groupItems = new TextSizeGroupItems(this);
    shrinkPerformer = new TextSizePerformShrink(this);
    growPerformer = new TextSizePerformGrow(this);
    // readonly endPerformer = new TextSizePerformEnd(this);
    borders = new TextSizeBorders(this);
    doesExceedBorder = false;
    constructor(parent) {
        this.parent = parent;
    }
    get group() {
        return this.parent;
    }
    lastTextSizingTime = 0;
    performSizing() {
        // avoid endless loops
        const answer = this.group.app.answer;
        if (answer) {
            if (answer.textSizeGroupLoops[this.group.groupName] > 10) {
                const groupName = this.group.groupName;
                setTimeout(() => (answer.textSizeGroupLoops[groupName] = 0), 200);
                return;
            }
            if (!answer.textSizeGroupLoops[this.group.groupName]) {
                answer.textSizeGroupLoops[this.group.groupName] = 1;
                return;
            }
            answer.textSizeGroupLoops[this.group.groupName]++;
        }
        const shouldAbort = this.beginPerformer.prepareSizing();
        if (shouldAbort)
            return;
        this.growPerformer.growLoop();
        this.shrinkPerformer.shrinkWhileBorderIsExceeded();
        const finalFontSize = Math.floor(this.groupItems.currentScaledFontSize / this.group.performer.parent.app.stage.stageInnerMeasure.stageDiagonalRatio);
        this.group.setFinalFontSize(finalFontSize);
        this.lastTextSizingTime = new Date().getTime();
    }
}
